import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    goatcounter?: {
      no_onload?: boolean;
      count?: (vars?: {
        path?: string;
        title?: string;
        referrer?: string;
        event?: boolean;
      }) => void;
    };
  }
}

/**
 * Records a GoatCounter page view on every route change.
 *
 * count.js is loaded in public/index.html with `no_onload: true` because in an
 * SPA the automatic onload count would only capture the first page load; this
 * component covers both the initial load and client-side navigations.
 * GoatCounter itself skips localhost, so dev traffic is never counted.
 */
function GoatCounterTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    if (window.goatcounter?.count) {
      window.goatcounter.count({ path });
      return;
    }
    // count.js loads async and may not be ready for the first page view yet
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (window.goatcounter?.count) {
        window.clearInterval(timer);
        window.goatcounter.count({ path });
      } else if (attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 250);
    return () => window.clearInterval(timer);
  }, [location.pathname, location.search]);

  return null;
}

export default GoatCounterTracker;
